var FieldViewModule = function (_app) {
  var AutocompleteListItemView = Backbone.View.extend({
    className: "checkout-autocomplete-list-item",
    events: {
      click: "click",
    },
    initialize: function (opts) {
      _.bindAll(this, "click", "remove", "selected");
      this.$el.text(this.model.get("description"));
      this.model.on("remove", this.remove);
      this.model.on("change:selected", this.selected);
    },
    click: function () {
      this.trigger("select", this.model.get("description"));
    },
    selected: function () {
      var value = this.model.get("selected");
      this.$el.toggleClass("checkout-autocomplete-list-item__selected", value);
    },
  });

  var AutocompleteListView = Backbone.View.extend({
    className: "checkout-autocomplete-list",
    initialize: function () {
      _.bindAll(this, "autocomplete", "add", "select", "blur");
      var settings = CheckoutSettings.getBasketSettings();
      this._sugg = new AddressSuggestion({
        SiteAccountID: settings.SiteAccountID,
      });

      this.autocompleteList = new AutocompleteCollection();

      this.autocompleteList.on("add", this.add);

      this.model.on("autocomplete", this.autocomplete);
      this.model.on("blur", this.blur);
    },
    autocomplete: function (value, e) {
      var _autocompleteList = this.autocompleteList;
      if (e.keyCode === 27) {
        //escape
        _autocompleteList.update([]);
      } else if (e.keyCode === 13) {
        //enter
        var value = _autocompleteList.getSelectedDescription();
        this.select(value);
      } else if (e.keyCode === 38) {
        //up
        _autocompleteList.selectPrev();
      } else if (e.keyCode === 40) {
        //down
        _autocompleteList.selectNext();
      } else {
        if (value && value.length > 3 && this.currentValue !== value) {
          this._sugg.getSuggestion(value).done(function (data) {
            data && _autocompleteList.update(data.predictions);
          });
        }
        if (!value || value.length <= 3) {
          _autocompleteList.update([]);
        }
        this.currentValue = value;
      }
    },
    add: function (model) {
      var listItem = new AutocompleteListItemView({ model: model });
      this.$el.append(listItem.$el);
      listItem.on("select", this.select);
    },
    select: function (value) {
      if (value) {
        var _this = this;
        this._sugg.getAddress(value).done(function (data) {
          _this.model.collection.each(function (model) {
            var key = model.getName();
            var value = data[key];
            value && model.set("Value", value);
            model._valueChanged(value, true, model.getName());
          });
        });
        this.autocompleteList.update([]);
      }
    },
    blur: function () {
      this.autocompleteList.update([]);
    },
  });

  var FieldView = Backbone.View.extend({
    events: {
      "change select": "change",
      "input input": "change", // Needed because 'keyup' event is not works properly for fast changes.
      "input textarea": "change",
      "keyup input": "change", // Only for <=IE9.
      "change input": "change",
      "mouseup input": "clearedByCross",
      "blur input": "blur",
      "input input[name='Forename']": "handleRecipientNameChange",
      "input input[name='Surname']": "handleRecipientNameChange",
      "input input[name='gift_Forename']": "handleRecipientNameChange",
      "input input[name='gift_Surname']": "handleRecipientNameChange",
    },

    initialize: function () {
      _.bindAll(this);
      var settings = CheckoutSettings.getBasketSettings();
      var data = this.model.toJSON();
      this.model.on("change:isValid", this.isValid);
      this.model.on("change:Value", this.updateValue);
      this.model.on("change:hidden", this._updateHidden);
      this.model.on("remove", this.remove);
      this.model.on("pcaUpdateModel", this._updateModel);
      this.model.on("clear", this._clear);

      this.$el = $.tmpl("bt-checkout-delivery-field", data);
      this.$field = this.$("input, select");
      this.$field.keyFilter(
        this.model.get("MaxLength"),
        this.model.get("Regexp")
      );

      // Input validations
      this.minLength = this.model.get("MinLength");

      InitTooltip(this.$("@info"), this.model.get("InfoTemplateName"));

      if (
        this.model.getName() === "AddressLines" &&
        settings.GoogleAddressSuggestionEnabled
      ) {
        var autocomplete = new AutocompleteListView({ model: this.model });
        this.$el.append(autocomplete.$el);
        if (_app && _app.event && _app.event.addressFieldFocus) {
          this.$field.on("focus", _app.event.addressFieldFocus);
        }
      }
    },
    handleRecipientNameChange: function (e) {
      this.change(e);

      switch (e.target.name) {
        case "Forename":
        case "Surname":
          {
            if (
              e.target.value.length < this.minLength ||
              e.target.value.trim() !== e.target.value
            ) {
              if (e.target.name === "Forename") {
                $("#ForenameValidation").text(
                  "Please provide a name with 2 or more characters, using letters only."
                );
                $("#Forename").addClass("errorField");
              } else {
                $("#SurnameValidation").text(
                  "Please provide a name with 2 or more characters, using letters only."
                );
                $("#Surname").addClass("errorField");
              }
            } else if (
              $("#Forename").val().trim().toLowerCase() ===
                $("#Surname").val().trim().toLowerCase() &&
              $("#Forename").val().length > 0 &&
              $("#Surname").val().length > 0
            ) {
              $("#ForenameValidation").text(
                "First and last name cannot be the same. Please enter different names."
              );
              $("#SurnameValidation").text(
                "First and last name cannot be the same. Please enter different names."
              );

              $("#Forename").addClass("errorField");
              $("#Surname").addClass("errorField");
            } else {
              $("#Forename").removeClass("errorField");
              $("#Surname").removeClass("errorField");

              $("#ForenameValidation").text("");
              $("#SurnameValidation").text("");
            }

            // Reset error element if name is not the same
            if (
              $("#Forename").val().trim().toLowerCase() !==
              $("#Surname").val().trim().toLowerCase()
            ) {
              if (
                $("#ForenameValidation").text() ===
                "First and last name cannot be the same. Please enter different names."
              ) {
                $("#Forename").removeClass("errorField");
                $("#ForenameValidation").text("");
              }

              if (
                $("#SurnameValidation").text() ===
                "First and last name cannot be the same. Please enter different names."
              ) {
                $("#Surname").removeClass("errorField");
                $("#SurnameValidation").text("");
              }
            }
          }
          break;

        case "gift_Forename":
        case "gift_Surname":
          {
            if (
              e.target.value.length < this.minLength ||
              e.target.value.trim() !== e.target.value
            ) {
              if (e.target.name === "gift_Forename") {
                $("#gift_ForenameValidation").text(
                  "Please provide a name with 2 or more characters, using letters only."
                );
                $("#gift_Forename").addClass("errorField");
              } else {
                $("#gift_SurnameValidation").text(
                  "Please provide a name with 2 or more characters, using letters only."
                );
                $("#gift_Surname").addClass("errorField");
              }
            } else if (
              $("#gift_Forename").val().trim().toLowerCase() ===
                $("#gift_Surname").val().trim().toLowerCase() &&
              $("#gift_Forename").val().length > 0 &&
              $("#gift_Surname").val().length > 0
            ) {
              $("#gift_ForenameValidation").text(
                "First and last name cannot be the same. Please enter different names."
              );
              $("#gift_SurnameValidation").text(
                "First and last name cannot be the same. Please enter different names."
              );

              $("#gift_Forename").addClass("errorField");
              $("#gift_Surname").addClass("errorField");
            } else {
              $("#gift_Forename").removeClass("errorField");
              $("#gift_Surname").removeClass("errorField");

              $("#gift_ForenameValidation").text("");
              $("#gift_SurnameValidation").text("");
            }

            // Reset error element if name is not the same
            if (
              $("#gift_Forename").val().trim().toLowerCase() !==
              $("#gift_Surname").val().trim().toLowerCase()
            ) {
              if (
                $("#gift_ForenameValidation").text() ===
                "First and last name cannot be the same. Please enter different names."
              ) {
                $("#gift_Forename").removeClass("errorField");
                $("#gift_ForenameValidation").text("");
              }

              if (
                $("#gift_SurnameValidation").text() ===
                "First and last name cannot be the same. Please enter different names."
              ) {
                $("#gift_Surname").removeClass("errorField");
                $("#gift_SurnameValidation").text("");
              }
            }
          }
          break;
      }
    },
    clearedByCross: function (e) {
      var _this = this;
      if (e.currentTarget.value === "") return;
      setTimeout(function () {
        if (e.currentTarget.value === "") _this.change(e);
      }, 0);
    },

    isValid: function () {
      var isValid = this.model.get("isValid");
      var isHidden = this.model.getHidden();
      if (isHidden || isValid === null || isValid === true) {
        this.$el
          .find("@form_field_content")
          .removeClass("form-field-second__error");
      } else {
        this.$el
          .find("@form_field_content")
          .addClass("form-field-second__error");
      }
    },

    updateValue: function (m) {
      if (m.hasChanged("Value")) {
        this.$field.val(this.model.get("Value"));
      }
    },

    // TBD: rethink events logic to avoid this horrible handling.
    change: function (e) {
      this.setValue(e.currentTarget.value);
      this.model.trigger("autocomplete", e.currentTarget.value, e);
    },

    // TBD: rethink events logic to avoid this horrible handling.
    blur: function () {
      var _this = this;
      setTimeout(function () {
        _this.model.trigger("blur");
      }, 500);
    },

    _updateModel: function () {
      var value = this.$field.val();
      value && this.setValue(value);
    },

    setValue: function (value) {
      this.model.off("change:Value", this.updateValue);
      this.model.setValue(value).setChangedByUser();
      this.model.on("change:Value", this.updateValue);
    },

    _updateHidden: function () {
      this.$el.toggleClass("hidden-block", this.model.getHidden());
    },

    _clear: function () {
      this.isValid();
      this.$field.val(this.model.get("Value"));
    },
  });

  return FieldView;
};
